import { toast } from 'react-toastify';

const success = (message) => {
  const id = toast.success(message, {autoClose: false});
  setTimeout(() => {
    toast.dismiss(id);
  }, 8000);
};

const error = (message) => {
  const id = toast.error(message, {autoClose: false});
  setTimeout(() => {
    toast.dismiss(id);
  }, 8000);
};

const info = (message) => {
  const id = toast.info(message, {autoClose: false});
  setTimeout(() => {
    toast.dismiss(id);
  }, 8000);
};

const warning = (message) => {
  const id = toast.warning(message, {autoClose: false});
  setTimeout(() => {
    toast.dismiss(id);
  }, 8000);
};

export default { success, error, info, warning };